import React from "react";
import { Link } from "react-router-dom";
import { cn } from "helper/Utils";

const VARIANT_CLASSES = {
  default: "bg-white text-gray-800 hover:bg-gray-100",
  green: "text-white bg-secondary border border-secondary",
  pink: "text-white bg-primary border border-primary",
  outline: "text-white border border-white/40",
};

const SIZE_CLASSES = {
  default: "px-4 h-9 text-sm",
  small: "px-2 py-1 text-[12px] leading-[30px]",
  medium: "px-4 py-2 text-sm",
  large: "px-6 py-3 text-sm",
};

const Button = ({ type = "button", to, onClick, label, prefix, postfix, className, disabled = false, variant = "default", size = "medium" }) => {
  const variantClass = disabled
    ? "disabled:bg-white/10 disabled:text-white/30 cursor-not-allowed"
    : VARIANT_CLASSES[variant] || VARIANT_CLASSES.default;
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.medium;

  return (
    <>
      {to ? (
        <Link
          to={to}
          className={cn(
            "flex justify-center items-center gap-2 font-medium rounded shadow-md hover:shadow-lg transition-all duration-300",
            variantClass,
            sizeClass,
            className
          )}
          aria-disabled={disabled}
        >
          {prefix && <span>{prefix}</span>}
          {label}
          {postfix && <span>{postfix}</span>}
        </Link>
      ) : (
        <button
          type={type}
          onClick={onClick}
          className={cn(
            "rounded flex justify-center gap-2 font-medium shadow-md hover:shadow-lg transition-all duration-300",
            variantClass,
            sizeClass,
            className
          )}
          disabled={disabled}
        >
          {prefix && <span>{prefix}</span>}
          {label}
          {postfix && <span>{postfix}</span>}
        </button>
      )}
    </>
  );
};

export default Button;
